module.exports = "/_next/static/images/c98aef6000befcb8f30cdf2b50c0e9b1-purple-man@1x.jpg";